import { render, staticRenderFns } from "./CloudAccountSetup.vue?vue&type=template&id=52388cb9&scoped=true"
import script from "./CloudAccountSetup.vue?vue&type=script&lang=js"
export * from "./CloudAccountSetup.vue?vue&type=script&lang=js"
import style0 from "./CloudAccountSetup.vue?vue&type=style&index=0&id=52388cb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52388cb9",
  null
  
)

export default component.exports